// @ts-nocheck
import  React, { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"


export const GPXTrajectoryComponents = (props) => {
    const ref = useRef();
    const [GPXList, setGPXList] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);



    const clickOnChange = () => {
        ref.current.click();
    }

    const handleOnPreview = (event) => {
        let list = [];
        let param = {};
        let track = null;
        let GPXEntity = null;

        list = GPXList;
        const newFile = event.target.files[0];

        if (newFile) {

            track = window.main.OView.getModule("track");
            track.depthTest = false;

            track.addGPXEntity({
                source: newFile, 
                callback:
                    function (ent) {
                        window.widgetTimeline.addLink(ent);
                        GPXEntity = ent;
                        // 取得GPX啟始結束時間並更新時間軸
                        window.widgetTimeline.updateTime(GPXEntity.playingInfo.TimeSpan[0]);
    
                        param.file = newFile;
                        param.entity = GPXEntity;
                        param.name = newFile.name;
                        param.ready = true;

                        list.push(param)
                        setGPXList(list);
    
                        forceUpdate();

                    }.bind(this)
            });
            // 為使檔案能購重複上傳
            event.target.value = '';
        }
    }

    // GPX開始移動
    const startToMove = (rowData) => {

        rowData.entity.goto();
        rowData.entity.show = true;
        rowData.ready = false;
        
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);
        timelinePlayer[0].play();
        forceUpdate();
    }

    // GPX停止移動
    const stopMoving = (rowData) => {

        rowData.ready = true;
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);
        timelinePlayer[0].stop();
        forceUpdate();
    }

    // 視窗移動至GPX位置
    const fieldgoto = (rowData) => {
        rowData.entity.goto();
    }

    // 顯示GPX
    const showGPX = (rowData) => {
        rowData.entity.show = true;
        forceUpdate();
    }

    // 不顯示GPX
    const unShowGPX = (rowData) => {
        rowData.entity.show = false;
        forceUpdate();
    }

    // 移除GPX圖層
    const fieldListRemove = (rowData) => {

        let timeline = window.main.OView.getWidgetByType(window.ov.Widget.Timeline);
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);
        let track = window.main.OView.getModule("track");
        let list = [];

        // 刪除與當下rowData相同名稱圖層
        for (let i = 0; i < GPXList.length; i++) {
            if (GPXList[i].name !== rowData.name) {
                list.push(GPXList[i]);
            }
        }
        timelinePlayer[0].reset();
        timeline[0].removeLink(rowData.entity);
        track.removeEntity(rowData.entity);

        setGPXList(list);
        forceUpdate();
    }

    // 設定rowData按鈕選項
    const actionBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                {
                    rowData.ready === true ?
                        <Button icon="pi pi-caret-right" className="p-button-rounded p-button-success mr-2" onClick={() => { startToMove(rowData) }} /> :
                        <Button icon="pi pi-pause" className="p-button-rounded p-button-info mr-2" onClick={() => { stopMoving(rowData) }} /> 
                }
                <Button icon="pi pi-map-marker" className="p-button-rounded mr-2" onClick={() => { fieldgoto(rowData) }} />    
                {
                    rowData.entity.show === false ?
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-warning mr-2" onClick={() => { showGPX(rowData) }} /> :
                        <Button icon="pi pi-eye-slash" className="p-button-rounded p-button-warning mr-2" onClick={() => { unShowGPX(rowData) }} />
                }
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { fieldListRemove(rowData) }} />
            </React.Fragment>
        )                                    
    }

    // 設定DataTable的標頭樣式
    const header = (
        <div style={{ background: 'rgb(53, 52, 147)', color: 'white', border: '1px solid #e4e4e4', borderWidth: '0 0 1px 0', padding: '0.75rem', fontWeight: '500', marginLeft: '-10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <h5 className="mx-0 my-1">Data Table</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    )

    return (
        <div>
            <Dialog header="GPX軌跡展示(測試用)" visible={props.Trajectory} modal={false} keepInViewport={false} onHide={() => props.onHide('Trajectory')}>
                <Card>
                    <DataTable value={GPXList} header={header} paginator rows={10} paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products" scrollable scrollHeight="350px" globalFilter={globalFilter} >
                        <Column field="name" header="Name" style={{ minWidth: '14rem' }} sortable />
                        <Column header="Action" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', display: 'flex' }} body={actionBodyTemplate} />
                    </DataTable>
                </Card>
                <br></br>
                <Card>
                    <div className="field grid">
                        <div className="col-12 md:col-12">
                            <Button label="上傳檔案" icon="pi pi-cloud-upload" className="p-button-raised" onClick={() => { clickOnChange() }} style={{ width: "100%" }} />
                            <input ref={ref} type="file" onChange={(e) => { handleOnPreview(e) }} style={{ display: "none" }} />
                        </div>
                    </div>
                </Card>
            </Dialog>
        </div>
    )
}